<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            registrationData: {
                type: Object
            }
        },
        computed: {
            ...mapState('sections',[
                'sectionCategoryMapping'
            ]),
            ...mapState('topbar',[
                "pageTopbarData",
                "schoolTopbarData",
            ]),
            ...mapState('footer',[
                'schoolFooterData',
                'pageFooterData',
            ]),
            getComponentForSection () {
                return this.envNamePrefix + this.uppercaseFirstLetter(this.findSectionType) + 'Section';
            },
            findSectionType () {

                let foundType = '';

                for (let sectionType in this.sectionCategoryMapping) {

                    if (!this.sectionCategoryMapping.hasOwnProperty(sectionType)) {
                        continue;
                    }

                    let sectionTypeIds = this.sectionCategoryMapping[sectionType];

                    if (sectionTypeIds.indexOf(this.registrationData.sectionTemplateId) > -1) {

                        foundType = sectionType;

                        //when initialising a topbar check topbar store module data to see if its the global school topbar or a page custom topbar
                        if ( foundType === "topbar") {                            
                            for (let topbarStatus in this.schoolTopbarData) {
                                if (!this.schoolTopbarData.hasOwnProperty(topbarStatus)) {
                                    continue;
                                }                                
                                if (this.schoolTopbarData[topbarStatus].sectionId === this.registrationData.sectionId) {
                                    foundType = "schoolTopbar";
                                }
                            }

                            for (let topbarStatus in this.pageTopbarData) {
                                if (!this.pageTopbarData.hasOwnProperty(topbarStatus)) {
                                    continue;
                                }

                                if (this.pageTopbarData[topbarStatus].sectionId === this.registrationData.sectionId) {
                                    foundType = "pageTopbar";
                                }
                            }
                        }

                        if ( foundType === "footer") {

                            for (let footerStatus in this.schoolFooterData) {
                                if (!this.schoolFooterData.hasOwnProperty(footerStatus)) {
                                    continue;
                                }
                                if (this.schoolFooterData[footerStatus].sectionId === this.registrationData.sectionId) {
                                    foundType = "schoolFooter";
                                }
                            }

                            for (let footerStatus in this.pageFooterData) {
                                if (!this.pageFooterData.hasOwnProperty(footerStatus)) {
                                    continue;
                                }

                                if (this.pageFooterData[footerStatus].sectionId === this.registrationData.sectionId) {
                                    foundType = "pageFooter";
                                }
                            }
                            //console.log("foundType: " , foundType)
                        }

                        break;
                    }
                }

                //make by default all non declared section templateId's html sections
                if (!foundType) {
                    foundType = "simple";
                }

                return foundType;
            },
        },
        methods: {
            uppercaseFirstLetter (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    }
</script>